import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const BarChartIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 9.2L8 9.2L8 19L5 19L5 9.2ZM10.6 5L13.4 5L13.4 19L10.6 19L10.6 5ZM16.2 13L19 13L19 19L16.2 19L16.2 13Z"
      fill="currentColor"
    />
  </svg>
);

BarChartIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(BarChartIcon);
